import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation, useParams } from 'react-router';
import {
  classDashboardPageUrl,
  getQueryParams,
  getReturnUrlAndRestOfQueryParams,
  studentSubmissionPageUrl,
} from '../helpers/url';
import assignmentTypes from '../utils/assignmentTypes';
import StudentSubmission from '../components/AssignmentSubmissionEvaluate/StudentSubmission';

const getAssignmentParams = assignmentType => {
  const history = useHistory();
  const { assignmentInstanceId, assignmentId } = useParams();
  const { classId, mloId, contentId, academicYearId } = getQueryParams(history);

  let assignmentParams = null;

  switch (assignmentType) {
    case assignmentTypes.TEACHER:
      assignmentParams = {
        assignmentInstanceId,
        classId,
        contentId,
        academicYearId,
        mloId,
      };
      break;
    case assignmentTypes.ALEF:
      assignmentParams = {
        assignmentId,
        classId,
        contentId,
        academicYearId,
        mloId,
      };
      break;

    default:
      throw new Error('assignmentType is not valid');
  }

  return assignmentParams;
};

const AssignmentSubmissionEvaluatePage = ({ assignmentType }) => {
  const history = useHistory();
  const { search } = useLocation();

  const searchParams = new URLSearchParams(search);
  const isGradableItemsLockedByDefault = searchParams.get(
    'isGradableItemsLockedByDefault',
  );

  const { studentId } = useParams();
  const returnUrl = getReturnUrlAndRestOfQueryParams();

  const onGoBack = ({
    assignmentId,
    assignmentInstanceId,
    mloId,
    classId,
    academicYearId,
  }) => {
    history.push(
      classDashboardPageUrl({
        assignmentId,
        assignmentInstanceId,
        mloId,
        classId,
        academicYearId,
        isGradableItemsLockedByDefault,
        returnUrl,
      }),
    );
  };

  const onMoveToNextStudent = ({
    assignmentInstanceId,
    studentId: nextStudentId,
    assignmentId,
    mloId,
    classId,
    contentId,
    academicYearId,
  }) =>
    history.push(
      studentSubmissionPageUrl({
        assignmentInstanceId,
        studentId: nextStudentId,
        assignmentId,
        mloId,
        contentId,
        classId,
        academicYearId,
        isGradableItemsLockedByDefault,
        returnUrl,
      }),
    );

  const onMoveToPrevStudent = ({
    assignmentInstanceId,
    studentId: prevStudentId,
    assignmentId,
    mloId,
    contentId,
    classId,
    academicYearId,
  }) =>
    history.push(
      studentSubmissionPageUrl({
        assignmentInstanceId,
        studentId: prevStudentId,
        assignmentId,
        mloId,
        classId,
        contentId,
        academicYearId,
        isGradableItemsLockedByDefault,
        returnUrl,
      }),
    );

  return (
    <StudentSubmission
      teacherAssignmentParams={
        assignmentType === assignmentTypes.TEACHER
          ? getAssignmentParams(assignmentType)
          : undefined
      }
      alefAssignmentParams={
        assignmentType === assignmentTypes.ALEF
          ? getAssignmentParams(assignmentType)
          : undefined
      }
      studentId={studentId}
      assignmentType={assignmentType}
      onGoBack={onGoBack}
      onMoveToNextStudent={onMoveToNextStudent}
      onMoveToPrevStudent={onMoveToPrevStudent}
    />
  );
};

export default AssignmentSubmissionEvaluatePage;

AssignmentSubmissionEvaluatePage.propTypes = {
  assignmentType: PropTypes.string.isRequired,
};
